module.exports = __webpack_public_path__ + "static/img/bg_coupon_three_grey_used.bc1070a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_three_grey_used.png
// module id = a3vN
// module chunks = 0